import script from "./TaskSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskSlider.vue?vue&type=script&lang=ts&setup=true"

import "./TaskSlider.vue?vue&type=style&index=0&id=5a74a041&lang=less"

const __exports__ = script;

export default __exports__